import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

export const PriceToggle = ({ onChange }) => {
  const [brand, setBrand] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => { setBrand(r.data); onChange?.(r.data.show_prices !== false); }); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!brand) return null;
  const on = brand.show_prices !== false;
  const toggle = async (v) => {
    const next = { ...brand, show_prices: v };
    setBrand(next);
    try {
      const { data: cur } = await api.get("/settings");
      await api.put("/settings", { ...cur, show_prices: v });
      onChange?.(v);
      toast.success(v ? "Prices shown in all catalogs" : "Prices hidden: all catalogs now say “On request”");
    } catch (e) { setBrand(brand); toast.error(errMsg(e)); }
  };
  return (
    <label className="flex items-center gap-2 text-sm border border-[var(--line)] bg-[var(--cream)] px-3 h-10 cursor-pointer" data-testid="price-toggle">
      <Switch checked={on} onCheckedChange={toggle} data-testid="price-toggle-switch" />
      <span data-testid="price-toggle-label">{on ? "Prices shown" : "Prices: On request"}</span>
    </label>
  );
};
